import * as ActionConfigurationManager from './config.actions';

export const loadEmail = ActionConfigurationManager.SAVE_EMAIL;
export const updateEmail = ActionConfigurationManager.UPDATE_EMAIL;
export const rehydrateEmail = ActionConfigurationManager.REHYDRATE_EMAIL
